export const CREATE_ORGCHART = 'Create OrgChart'
export const CREATE_MANAGEMENT_TEAM = 'Create Management Structure'
export const CREATE_GOVERNANCE_SETUP = 'Create Compliance Setup'
export const CREATE_RISK = 'Create Risk'
export const CREATE_USER_MANAGEMENT = 'Create User Management'
export const CREATE_MANAGEMENT_STRUCTURE = 'Create Management Structure'
export const UPDATE_ORGCHART = 'Update OrgChart'
export const UPDATE_MANAGEMENT_TEAM = 'Update Management Structure'
export const UPDATE_GOVERNANCE_SETUP = 'Update Compliance Setup'
export const UPDATE_RISK = 'Update Risk'
export const UPDATE_COMPLIANCE = 'Update Manage Compliance'
export const UPDATE_USER_MANAGEMENT = 'Update User Management'
export const UPDATE_MANAGEMENT_STRUCTURE = 'Update Management Structure'
export const VIEW_ORGCHART = 'View OrgChart'
export const VIEW_MANAGEMENT_TEAM = 'View Management Structure'
export const VIEW_GOVERNANCE_SETUP = 'View Compliance Setup'
export const VIEW_RISK = 'View Risk'
export const VIEW_COMPLIANCE = 'View Manage Compliance'
export const VIEW_USER_MANAGEMENT = 'View User Management'
export const VIEW_MANAGEMENT_STRUCTURE = 'View Management Structure'
